import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { Anlage } from "../models/anlage"
import { DateiAnlage } from "../models/dateianlage"
import { UploadAnlage } from "../models/uploadanlage"
import { UrlAnlage } from "../models/urlanlage"
import { CONFIG } from "../services/ConfigService"
import { FeatureService } from "../services/FeatureService"
import { useStoreRechnung } from "../store"
import { AnlageWrapperView } from "./anlagen/AnlageWrapperView"
import { DateiAnlageView } from "./anlagen/DateiAnlageView"
import { UploadAnlageView } from "./anlagen/UploadAnlageView"
import { UrlAnlageView } from "./anlagen/UrlAnlageView"

export function AnlagenView() {
    const { t } = useTranslation()
    const { anlagen } = useStoreRechnung("anlagen")

    let customAttachments = CONFIG?.attachments
    if (customAttachments) {
        customAttachments = customAttachments.map((element) => t(element))
    }

    const attachments = customAttachments || [t("rechnung.anlagen.dateiAnlage.title"), t("rechnung.anlagen.urlAnlage.title")]

    const addAnlage = useCallback(
        (item: string) => {
            const newInstance = item === t("rechnung.anlagen.dateiAnlage.title") ? new UploadAnlage() : new UrlAnlage()
            newInstance._frontendId = Math.random()
            EventBus.instance.emit("addAnlage", newInstance)
        },
        [t],
    )

    const disabled = FeatureService.isFeatureActive("DEMO")

    return (
        <Components.Collapsible title={t("rechnung.anlagen.title")} collapsed={false}>
            {anlagen.map((a: Anlage, idx: number) => {
                const key = a._frontendId
                if (a instanceof UrlAnlage)
                    return (
                        <AnlageWrapperView key={key} index={idx} anlage={a} t={t}>
                            <UrlAnlageView anlage={a} index={idx} />
                        </AnlageWrapperView>
                    )
                if (a instanceof DateiAnlage)
                    return (
                        <AnlageWrapperView key={key} index={idx} anlage={a} t={t}>
                            <DateiAnlageView index={idx} anlage={a} />
                        </AnlageWrapperView>
                    )
                if (a instanceof UploadAnlage)
                    return (
                        <AnlageWrapperView key={key} index={idx} anlage={a} t={t}>
                            <UploadAnlageView index={idx} anlage={a} />
                        </AnlageWrapperView>
                    )
                return ""
            })}
            <Components.Row>
                <div className="col-auto me-auto" />
                <div className="col-auto">
                    <Components.DropdownButton
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.anlagen.dropdown")}
                        menuItems={attachments}
                        onItemSelected={addAnlage}
                        disabled={disabled}
                        tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                        tooltipAtDisabled={disabled}
                    />
                </div>
            </Components.Row>
        </Components.Collapsible>
    )
}
